/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import bench from './bench'
import { loop, endLoop } from './util'

export default class Canvas {

    constructor(canvas, renderer) {
        this.size = { w: 0, h: 0, scale: 0 } 
        this.canvas = canvas
        this.renderer = renderer
        this.requestId = null
        this.intervalId = null
        this.lastTickAt = 0
        this.providers = []
        this.listeners = []
        this.children = []
        this.map = []
        this.ticks = 0
        this.library = {}

        this.tick = this.tick.bind(this)
    }

    start() {
        if (!this.requestId) {
            this.size = this.renderer.setupCanvas(this.canvas)
            this.requestId = loop(this.tick)
        }
    }

    stop() {
        if (this.requestId) {
            endLoop(this.requestId)
            this.requestId = null
        }
    }

    tick(time) {
        let mark = bench('TRCCanvas.tick')
        this.ticks ++

        let delta = time - this.lastTickAt

        this.render(time, delta)
        if (!this.intervalId) {
            const that = this
            this.intervalId = setTimeout(function() {
                that.update(time, delta)
                that.intervalId = null
            }, 3)
        } else {
            console.warn('TRCCanvas.tick', 'skipping update, it is taking to long')
        }

        this.lastTickAt = time
        loop(this.tick)

        mark.end('warn', 18)
    }

    register(key, value) {
        this.library[key] = value
    }

    add(child) {
        this.children.push(child)
    }

    remove(child) {
        this.children = this.children.filter(c => c !== child)
    }

    updateFromMap() {
        // add map items missing in children
        for (let m of this.map) {
            let missing = true
            for (let c of this.children) {
                if (c._key === m.key) {
                    missing = false
                    // update child
                    c.frame = m.frame
                    break
                }
            }
            if (missing) {
                let drw = new this.library[m.draw](m.frame)
                console.log('adding missing', drw)
                drw._key = m.key
                this.add(drw)
            }
        }

    }
    
    update(time, delta) {
        for (let p of this.providers) {
            p.update(this.size, time, delta)
        }
        this.updateFromMap()
    }

    render(time, delta) {
        if (this.frames % 60 === 1) {
            console.log('TRCCanvas.render', Math.round(1000/delta), 'fps')
        }
        const ctx = this.renderer.getContext(this.canvas)
        this.renderer.clear(ctx)

        for (let child of this.children) {
            child.draw(this.renderer, ctx)
        }
    }

}



